export default function isString(value) {
    return typeof value === 'symbol';
}
